export const PDP_MAIN_META_KEYWORDS = 'pdp.main.meta.keywords';
